import React from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Select, Switch, Row, Col, Statistic } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { baseAxiosNoInfo, baseAxiosComplete } from '../../tool/axios'
import { SelectStores } from '../../component/common/Selects'
import BreadCrumb from '../../component/BreadCrumb'

const { Column } = Table
const { Option } = Select

interface State {
    data: object[],
    loading: boolean,
    myStatus: any,
    newMyStatus: any,
    pagination: {
        current: number,
        pageSize: number,
        total: number
    },
    fetchOtherParams: {
        store_id: string | null,
        user_name: string | null,
        phone: string | null,
        is_forbidden: string | null,
        is_new: string | null
    },
    offShelfVisible: boolean,
    sales_num: number
}

export default class CkOrderList extends React.Component {
    state: State = {
        data: [],
        loading: false,
        myStatus: [{ id: 0, name: '是' }, { id: 1, name: '否' }],
        newMyStatus: [{ id: 1, name: '是' }, { id: 0, name: '否' }],
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        fetchOtherParams: {
            store_id: null,
            user_name: null,
            phone: null,
            is_forbidden: null,
            is_new: null
        },
        offShelfVisible: false,
        sales_num: 0
    }

    componentDidMount() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    handleInputChange(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.user_name = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleInputChange2(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.phone = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleSelectChange = (value: string, attr: string) => {
        let { fetchOtherParams } = this.state;
        fetchOtherParams.store_id = value

        this.setState({
            fetchOtherParams
        })
    }

    handleSelectChange1(value: string) {
        let { fetchOtherParams } = this.state;
        fetchOtherParams.is_new = value

        this.setState({
            fetchOtherParams
        })
    }

    handleSelectChange2(value: string) {
        let { fetchOtherParams } = this.state;
        fetchOtherParams.is_forbidden = value

        this.setState({
            fetchOtherParams
        })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current
        pagination.pageSize = antPagination.pageSize

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    selectState(type: string) {
        let { pagination, fetchOtherParams } = this.state;

        if (type != 'current') {
            pagination.current = 1;
        }

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    selectExcel(type: string) {
        let { pagination, fetchOtherParams } = this.state;

        if (type != 'current') {
            pagination.current = 1;
        }

        this.exportExcel({
            pagination,
            fetchOtherParams
        })
    }

    onChange(id: any, type: string, value: any) {
        let url: string = '';
        let param: any = { id }

        if (value == null || value == undefined) {
            value = 0

        } else {
            value = value == 1 ? 0 : 1
        }

        if (type == 'new') {
            url = "/markting_center/sales/switch_is_new"
            param.is_new = value

        } else {
            url = "/markting_center/sales/switch_is_forbidden"
            param.is_forbidden = value
        }

        baseAxiosComplete.post(url, param).then((res: any) => {
            this.selectState('current')
        })
    }

    onChanges = (value: any, selectedOptions: any) => {
        let store: any = selectedOptions[selectedOptions.length - 1];
        let { fetchOtherParams } = this.state;

        if (value.length == 2) {
            fetchOtherParams.store_id = store.id

            this.setState({
                fetchOtherParams,
                chooseItem: value
            })

        } else {
            fetchOtherParams.store_id = null

            this.setState({
                fetchOtherParams,
                chooseItem: []
            })
        }
    }

    onChangess(id: any, type: string, value: any) {
        let url: string = '';
        let param: any = { id }

        if (value == null || value == undefined) {
            value = 1

        } else {
            value = value == 1 ? 0 : 1
        }

        url = "/markting_center/sales/switch_is_new"
        param.is_new = value

        baseAxiosComplete.post(url, param).then((res: any) => {
            this.selectState('current')
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        baseAxiosNoInfo.get('/markting_center/sales/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                const { pagination } = this.state
                pagination.total = response.total
                pagination.pageSize = response.size
                pagination.current = response.current

                this.setState({
                    pagination,
                    sales_num: response.today_work_sales_num,
                    data: response.records
                })
            }
        })
    }

    resetForm() {
        let { fetchOtherParams } = this.state
        fetchOtherParams.store_id = null
        fetchOtherParams.user_name = null
        fetchOtherParams.phone = null
        fetchOtherParams.is_forbidden = null
        fetchOtherParams.is_new = null

        this.setState({ fetchOtherParams })
        this.selectState('')
    }

    exportExcel({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        baseAxiosComplete('/markting_center/sales/excel', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    render() {
        let { store_id, user_name, phone, is_new, is_forbidden } = this.state.fetchOtherParams

        return (<div className="common-page">
            {/* 营销中心 -> 销售管理 -> 销售列表 */}
            <BreadCrumb position={['营销中心', '销售列表']} />

            <Row gutter={16} style={{ marginBottom: 20, marginLeft: 20 }}>
                <Col span={6}>
                    <Statistic title="今日上班" value={this.state.sales_num} />
                </Col>
            </Row>

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <div style={{ marginRight: 8, marginBottom: 12 }}>
                        <SelectStores valueProp="id" value={store_id as string} onChange={(value: string) => { this.handleSelectChange(value, 'store_id') }} />
                    </div>
                    <Input style={{ width: '120px', marginRight: 8, marginBottom: 12 }} placeholder="员工姓名" value={user_name === null ? '' : user_name} onChange={this.handleInputChange.bind(this)} />
                    <Input style={{ width: '120px', marginRight: 8, marginBottom: 12 }} placeholder="员工手机号" value={phone === null ? '' : phone} onChange={this.handleInputChange2.bind(this)} />

                    <Select allowClear={true} value={is_new as string} style={{ marginRight: 8, marginBottom: 12, width: 160 }} onChange={this.handleSelectChange1.bind(this)} placeholder="是否接受流失客资">
                        {this.state.newMyStatus.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.name}</Option>
                        })}
                    </Select>
                    <Select allowClear={true} value={is_forbidden as string} style={{ marginRight: 8, marginBottom: 12, width: 130 }} onChange={this.handleSelectChange2.bind(this)} placeholder="是否启用">
                        {this.state.myStatus.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.name}</Option>
                        })}
                    </Select>
                </Space>

                <div style={{ marginTop: 10 }}>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={this.selectState.bind(this, '')}>查询</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={this.resetForm.bind(this)}>重置</Button>
                    <Button type="dashed" onClick={this.selectExcel.bind(this, '')}>导出</Button>
                </div>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} bordered={true} scroll={{ x: 'max-content' }} pagination={this.state.pagination} rowKey="id" onChange={this.handleTableChange}>
                    <Column title="门店名称" dataIndex="store_name" key="store_name" />
                    <Column title="员工姓名" dataIndex="user_name" key="user_name" />
                    <Column title="员工手机号" dataIndex="phone" key="phone" />
                    <Column title="限制客资数" dataIndex="customer_limit_num" key="customer_limit_num" />
                    <Column title="接收倍数" dataIndex="accept_multiple" key="accept_multiple" render={(value: any): string => value ? value : 0} />
                    <Column title="当日接收客资" dataIndex="today_accept_num" key="today_accept_num" render={(value: any): string => value ? value : 0} />

                    <Column title="是否接收流失客资" dataIndex="is_new" render={(text, record: any) => (
                        <Space size="middle">
                            <Switch checked={record.is_new == undefined || record.is_new == null || record.is_new == 0 ? false : true} onChange={this.onChangess.bind(this, record.id, 'new', record.is_new)} />
                        </Space>
                    )} />
                    <Column title="是否启用" dataIndex="is_forbidden" key="is_forbidden" render={(text, record: any) => (
                        <Space size="middle">
                            <Switch checked={record.is_forbidden == undefined || record.is_forbidden == null || record.is_forbidden == 1 ? false : true} onChange={this.onChange.bind(this, record.id, 'forbidden', record.is_forbidden)} />
                        </Space>
                    )} />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record: any) => (
                            <Space size="middle">
                                <Link to={"/sales_edit/" + record.id}><Button type="primary">编辑</Button></Link>
                            </Space>
                        )}
                    />
                </Table>
            </div>
        </div>)
    }
}